import { useEffect, useRef } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import { useProducts } from "@/hooks/useProducts";

const parseItems = (raw) =>
  (raw || "")
    .split(",")
    .map((part) => {
      const [slug, qty] = part.split(":");
      return { slug: (slug || "").trim(), quantity: Math.min(20, Math.max(1, parseInt(qty, 10) || 1)) };
    })
    .filter((i) => i.slug);

export default function Reorder() {
  const [params] = useSearchParams();
  const { data: products, isLoading, isError } = useProducts();
  const { items: cart, add, update, setOpen } = useCart();
  const done = useRef(false);

  useEffect(() => {
    if (done.current || isLoading) return undefined;
    done.current = true;
    const wanted = parseItems(params.get("p"));
    const list = Array.isArray(products) ? products : [];
    let added = 0;
    wanted.forEach(({ slug, quantity }) => {
      const product = list.find((p) => p.slug === slug && p.active !== false && p.stock > 0);
      if (!product) return;
      const qty = Math.min(quantity, product.stock);
      const existing = cart.find((c) => c.slug === slug);
      if (existing) update(slug, Math.max(existing.quantity, qty));
      else add(product, qty);
      added += 1;
    });
    if (added > 0) {
      setOpen(true);
      if (added < wanted.length) toast("Alcuni prodotti del tuo ordine non sono al momento disponibili.");
    } else {
      toast(isError ? "Non riusciamo a caricare i prodotti. Riprova tra poco." : "I prodotti del tuo ordine non sono al momento disponibili.");
    }
    return undefined;
  }, [isLoading, isError, products, params, cart, add, update, setOpen]);

  if (isLoading) {
    return <div className="grid min-h-screen place-items-center bg-ivory pt-32 text-lg text-slate2" data-testid="reorder-loading">Stiamo preparando il tuo carrello…</div>;
  }
  return <Navigate to="/collezione" replace />;
}
